import { Role } from "@shared/contexts"
import { Message } from "@shared/hooks/useMessages"
import { getRef } from "@shared/modules"

import { camelCasify } from "casify"

function toMessage(message: any): Message {
  return camelCasify(message) as Message
}

async function getMessages(
  scheduleKey: string,
  role: Role,
): Promise<Message[]> {
  const messageObject = await (
    await getRef("messages")
      .child(scheduleKey)
      .orderByChild("role")
      .equalTo(role)
      .once("value")
  ).val()

  if (!messageObject) return []

  return Object.keys(messageObject).map((key) => {
    let message: Message = toMessage(messageObject[key])
    message.key = key
    message.beautifulBody = message.body
    return message
  })
}

async function getManagerMessages(scheduleKey: string): Promise<Message[]> {
  const streamerMsg = await getMessages(scheduleKey, "STREAMER")
  const managerMsg = await getMessages(scheduleKey, "MANAGER")
  return [...streamerMsg, ...managerMsg].sort(
    (prev: Message, next: Message) => prev.timestamp! - next.timestamp!,
  )
}

async function getSystemMessage(scheduleKey: string): Promise<Message[]> {
  return getMessages(scheduleKey, "SYSTEM")
}

export default {
  toMessage,
  getMessages,
  getManagerMessages,
  getSystemMessage,
}
